import initialStates from '../../initialStates';
import {
    SHOP_PRICE_LIST_FAILURE,
    SHOP_PRICE_LIST_SUCCESS,
} from './shopPriceList-actions';

const shopPriceList = (state = initialStates.shopPriceList, action) => {
    let newState;
    switch (action.type) {
    case SHOP_PRICE_LIST_SUCCESS:
        newState = {
            list: action.data.content,
            page: action.page,
            size: action.size,
            first: action.data.first,
            totalElements: action.data.totalElements,
            last: action.data.last,
            filterValues: action.filterValues,
        };
        break;
    case SHOP_PRICE_LIST_FAILURE:
        newState = { ...initialStates.shopPriceList };
        break;
    default:
        newState = state;
    }
    return newState;
};

export default shopPriceList;
